import { axiosPrivate } from "./axios";

// Create a new ticket
export const createTicket = async (ticketData) => {
  const response = await axiosPrivate.post("/api/tickets", ticketData);
  return response.data;
};

// Get all tickets
export const getAllTickets = async () => {
  const response = await axiosPrivate.get("/api/tickets");
  return response.data;
};

// Get a single ticket by ID
export const getTicketById = async (ticketId) => {
  const response = await axiosPrivate.get(`/api/tickets/${ticketId}`);
  return response.data;
};

// Add a message to a ticket (text required unless attachment/attachmentUrl; files uploaded to Supabase)
export const addMessage = async (ticketId, payload) => {
  const body =
    typeof payload === "string"
      ? { text: payload }
      : {
          text: payload.text ?? "",
          attachment: payload.attachment ?? undefined,
          attachmentUrl: payload.attachmentUrl ?? undefined,
          attachmentFilename: payload.attachmentFilename ?? undefined,
        };
  const response = await axiosPrivate.post(
    `/api/tickets/${ticketId}/messages`,
    body,
  );
  return response.data;
};

// Close a ticket (creator only — immediate close)
export const closeTicket = async (ticketId) => {
  const response = await axiosPrivate.post(`/api/tickets/${ticketId}/close`);
  return response.data;
};

// Assignee requests close — creator must confirm or cancel
export const requestClose = async (ticketId) => {
  const response = await axiosPrivate.post(
    `/api/tickets/${ticketId}/request-close`,
  );
  return response.data;
};

// Creator confirms close (ticket closes, closedBy = who requested)
export const confirmClose = async (ticketId) => {
  const response = await axiosPrivate.post(
    `/api/tickets/${ticketId}/confirm-close`,
  );
  return response.data;
};

// Creator cancels close — assignee can send messages again
export const cancelClose = async (ticketId) => {
  const response = await axiosPrivate.post(
    `/api/tickets/${ticketId}/cancel-close`,
  );
  return response.data;
};

// Add participants to a ticket (creator only)
export const addParticipants = async (ticketId, participantIds) => {
  const response = await axiosPrivate.post(
    `/api/tickets/${ticketId}/participants`,
    { participantIds },
  );
  return response.data;
};

// Edit a message text (only while ticket status is "open"; own messages only)
export const editMessage = async (ticketId, messageId, text) => {
  const response = await axiosPrivate.put(
    `/api/tickets/${ticketId}/messages/${messageId}`,
    { text },
  );
  return response.data;
};
